export default "__VITE_ASSET__DoSdout0__"